/* eslint-disable import/order */
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import {
	getQueuesResources,
	getServiceDeskSettingsResources,
} from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { servicedeskPracticeManageViewRoute } from '@jira/router-routes__servicedesk-queues-routes/src/servicedeskPracticeManageViewRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import ServicedeskQueuesManageView, {
	LazyServicedeskQueuesManageView,
} from './ui/manage-view/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

const getNavigationSpecifications = () => {
	return (
		fg('jsm_manage_queues_in_space_settings') && {
			sidebarId: SidebarIdProjectSettings,
		}
	);
};

export const servicedeskPracticeManageViewRouteEntry: Route = createEntry(
	servicedeskPracticeManageViewRoute,
	() => ({
		group: 'servicedesk',
		// eslint-disable-next-line no-restricted-syntax
		component: ServicedeskQueuesManageView,
		layout: serviceProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
			...getNavigationSpecifications(),
		},

		resources: fg('jsm_manage_queues_in_space_settings')
			? [...getServiceDeskSettingsResources(), ...getQueuesResources()]
			: getQueuesResources(),
		forPaint: [LazyAtlassianNavigation, LazyServicedeskQueuesManageView],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
